import { render, staticRenderFns } from "./InterCommDiscFactorQuery.vue?vue&type=template&id=52a7b850&"
import script from "./InterCommDiscFactorQuery.vue?vue&type=script&lang=js&"
export * from "./InterCommDiscFactorQuery.vue?vue&type=script&lang=js&"
import style0 from "./InterCommDiscFactorQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InterCommDiscFactorQuery.vue"
export default component.exports